@switch (columnName) {
  @case ('startedAt') {
    {{ element[columnName] | date: dateTimeFormat }}
  }
  @case ('completedAt') {
    {{ element[columnName] | date: dateTimeFormat }}
  }
  @case ('type') {
    {{ element[columnName] | translate }}
  }
  @case ('exportProcessErrors') {
    @if (element.errors?.length) {
      <ul class="export-error-list">
        @for (error of element.errors; track error.stepId) {
          <li>{{ error.message }}</li>
        }
      </ul>
    }
  }
  @default {
    {{ element[columnName] }}
  }
}
